module.exports = __webpack_public_path__ + "img/tibet.64a0f086.svg";